<template>
  <div class="component-wrap" v-if="hasProgramList">
    <div class="analysis-title-box">
      <h3 class="analysis-title">많이 본 프로그램</h3>
    </div>
    <div v-if="hasProgramList" class="mypooq-swiper-container my-component01" id="swiper-container01">
      <ul class="mypooq-swiper-wrapper">
        <li class="mypooq-swiper-slide" v-for="(data, index) in filteredProgramList" :key="index">
          <a href="" @click.prevent="()=>goUrl(data)">
            <span class="program-img">
              <img v-lazy="getLazyLoadObj(data)" alt=""/>
              <!--<img :src="'https://' + data.image" alt=""/>-->
            </span>
            <span class="thumb-text-wrap">
            <span class="thumb-text-right">
            <strong class="thumb-title-two">{{data.programtitle}}</strong>
            <span class="thumb-text01">{{Math.ceil(data.viewtime / 3600)}}시간</span>
            </span>
            </span>
          </a>
        </li>
      </ul>
      <span class="scrollbar-none"></span>
    </div>
    <taste-analysis-empty v-else :go-home-fn="goHome"></taste-analysis-empty>
  </div>
</template>

<script>

import { resizeThumbnail } from '@/common/image.filter'
import TasteAnalysisEmpty from '@/components/lnb/mypooq/TasteAnalysisEmpty'

export default {
  components: {
    TasteAnalysisEmpty
  },
  props: {
    dataList: {
      type: Array,
      required: true,
      default: function () {
        return []
      }
    },
    device: {
      type: String
    }
  },
  data () {
    return {}
  },
  computed: {
    filteredProgramList () {
      return this.dataList.filter((item, index) => index < 30)
    },
    hasProgramList () {
      return this.dataList.length > 0
    }
  },
  methods: {
    getLazyLoadObj (data) {
      return {
        src: resizeThumbnail(data.image, { width: 104, height: 156, quality: 75, multiply: 3 }),
        error: '/img/common/img_default_thum_3.png',
        loading: '/img/common/img_default_thum_3.png'
      }
    },
    goUrl (data) {
      if (this.device === 'mobile') {
        this.$router.push('/player/vod?programid=' + data.programid + '&referer=' + this.$route.fullPath)
      } else {
        location.href = 'captvpooq://player/vod?programid=' + data.programid
      }
    },
    goHome () {
      if (this.device === 'mobile') {
        this.$router.push('/')
      } else {
        location.href = 'captvpooq://index'
      }
    }
  }
}
</script>
